// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__RhlDe > div {
  width: 90%; }

.styles_container__RhlDe .styles_options__GKrid {
  margin: 1rem;
  height: fit-content; }

.styles_container__RhlDe input {
  min-width: 36rem;
  margin: 1rem 0rem;
  height: 1.5rem;
  padding: 0.5rem 1rem; }

.styles_card__8wQH\\+ {
  border: none; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/BoothEntriesTab/styles.module.scss"],"names":[],"mappings":"AACA;EAEQ,UAAU,EAAA;;AAFlB;EAMQ,YAAY;EAEZ,mBAAmB,EAAA;;AAR3B;EAWQ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB,EAAA;;AAI5B;EACI,YAAY,EAAA","sourcesContent":["\n.container { \n    & > div {\n        width: 90%;\n    }\n\n    .options {\n        margin: 1rem;\n        // padding: 1rem;\n        height: fit-content;\n    }\n    input {\n        min-width: 36rem;\n        margin: 1rem 0rem;\n        height: 1.5rem;\n        padding: 0.5rem 1rem;\n    }\n}\n\n.card {\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__RhlDe`,
	"options": `styles_options__GKrid`,
	"card": `styles_card__8wQH+`
};
export default ___CSS_LOADER_EXPORT___;
